import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectComments } from "../Post/postSlice";

import Comment from "./Comment";

const Comments = () => {
  const comments = useSelector(selectComments);
  return (
    <div className="comments">
      <Link to="/">
        <button className="comment-btn">Home</button>
      </Link>
      {comments.map((comment) => (
        <div key={comment.data.id}>{<Comment comment={comment} />}</div>
      ))}
      <Link to="/">
        <button className="comment-btn">Home</button>
      </Link>
    </div>
  );
};

export default Comments;
